import { createSlice } from "@reduxjs/toolkit";
import initialState from "@/redux/slice/location/initialState";
import syncLocationActionReducers from "@/redux/slice/location/reducers/actionReducers";
import asyncLocationReducers from "@/redux/slice/location/reducers/extraReducers";

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: syncLocationActionReducers,
  extraReducers: asyncLocationReducers,
});

export const {
  updateAddressList,
  updateSpecifiedLocation,
  updateHeaderPincodeError,
  updateCurrentAddressId,
  updateIsAddressListUpdated,
  updateIsAddressUpdated,
  updatePickAddressDialogOpen,
  updateAddAddressDialogOpen,
  updateEditAddressId,
  updateIsPincodeServiceable,
  updateShowPincodeModal,
  updatePlaceDetailsStatus,
  updateAddressLoading,
  updateCurrentLocationUpdated,
  updateOpenChangeAddressPopup,
  updateIsAlertOpen,
  updateIsGreyBackground,
  updateAlertMessage,
  updateFetchingSearchPlaceSuggestions,
  updateUserFromApp,
  updateUserFromAppFooter,
} = locationSlice.actions;

export default locationSlice.reducer;
